(function () {
  const MOBILE_BREAKPOINT = '(max-width: 767px)';
  const MOBILE_BATCH = 8;
  const isMobile = () => window.matchMedia(MOBILE_BREAKPOINT).matches;

  const hideExtras = (grid) => {
    if (!isMobile()) return;
    Array.from(grid.children).forEach((child, i) => {
      if (i >= MOBILE_BATCH && !child.dataset.mobileShown) {
        child.classList.add('is-mobile-hidden');
      }
    });
  };

  document.querySelectorAll('.collection--best-sellers .collection--product-list').forEach(hideExtras);

  const buttons = document.querySelectorAll('.collection--load-more');

  const handleClick = async (button) => {
    if (button.classList.contains('is-loading')) return;
    const grid = document.getElementById(button.dataset.gridId || 'product-grid');
    if (!grid) return;

    if (isMobile()) {
      const hidden = grid.querySelectorAll('.is-mobile-hidden');
      if (hidden.length > 0) {
        Array.from(hidden).slice(0, MOBILE_BATCH).forEach((el) => {
          el.classList.remove('is-mobile-hidden');
          el.dataset.mobileShown = '1';
        });
        if (grid.querySelectorAll('.is-mobile-hidden').length === 0 && !button.dataset.nextUrl) {
          button.closest('.collection--load-more-wrap')?.remove();
        }
        return;
      }
    }

    const nextUrl = button.dataset.nextUrl;
    if (!nextUrl) {
      button.closest('.collection--load-more-wrap')?.remove();
      return;
    }

    button.classList.add('is-loading');
    button.disabled = true;

    try {
      const res = await fetch(nextUrl, { headers: { 'Accept': 'text/html' } });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const nextGrid = doc.getElementById(button.dataset.gridId || 'product-grid');
      if (nextGrid) {
        const newChildren = Array.from(nextGrid.children);
        const fragment = document.createDocumentFragment();
        newChildren.forEach((child) => fragment.appendChild(child));
        grid.appendChild(fragment);

        if (isMobile() && grid.closest('.collection--best-sellers')) {
          newChildren.forEach((child, i) => {
            if (i >= MOBILE_BATCH) child.classList.add('is-mobile-hidden');
          });
        }
      }

      const nextButton = doc.querySelector('.collection--load-more');
      if (nextButton && nextButton.dataset.nextUrl) {
        button.dataset.nextUrl = nextButton.dataset.nextUrl;
      } else {
        button.dataset.nextUrl = '';
        if (grid.querySelectorAll('.is-mobile-hidden').length === 0) {
          button.closest('.collection--load-more-wrap')?.remove();
        }
      }
    } catch (err) {
      console.error('Load more failed:', err);
    } finally {
      button.classList.remove('is-loading');
      button.disabled = false;
    }
  };

  buttons.forEach((button) => {
    button.addEventListener('click', () => handleClick(button));
  });

  const triggers = document.querySelectorAll('.collection--infinite-scroll');
  if (!triggers.length || !('IntersectionObserver' in window)) return;

  const loadNext = async (trigger, observer) => {
    if (trigger.dataset.loading === '1') return;
    const grid = document.getElementById(trigger.dataset.gridId || 'product-grid');
    const nextUrl = trigger.dataset.nextUrl;
    if (!grid || !nextUrl) {
      observer.disconnect();
      trigger.remove();
      return;
    }

    trigger.dataset.loading = '1';

    try {
      const res = await fetch(nextUrl, { headers: { Accept: 'text/html' } });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const nextGrid = doc.getElementById(trigger.dataset.gridId || 'product-grid');
      if (nextGrid) {
        const fragment = document.createDocumentFragment();
        Array.from(nextGrid.children).forEach((child) => fragment.appendChild(child));
        grid.appendChild(fragment);
      }

      const nextTrigger = doc.querySelector('.collection--infinite-scroll');
      if (nextTrigger && nextTrigger.dataset.nextUrl) {
        trigger.dataset.nextUrl = nextTrigger.dataset.nextUrl;
        trigger.dataset.loading = '';
      } else {
        observer.disconnect();
        trigger.remove();
      }
    } catch (err) {
      console.error('Infinite scroll failed:', err);
      trigger.dataset.loading = '';
    }
  };

  triggers.forEach((trigger) => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) loadNext(trigger, observer);
      });
    }, { rootMargin: '400px 0px' });
    observer.observe(trigger);
  });
})();
